export const API_BASE_URL = import.meta.env.VITE_API_URL || (process.env.NODE_ENV === 'development' 
    ? 'http://localhost:8000' 
    : 'https://vidgencraft.com/api');
  
  export const WS_BASE_URL = import.meta.env.VITE_WS_URL || (process.env.NODE_ENV === 'development'
    ? 'ws://localhost:8000'
    : 'wss://vidgencraft.com/api');